import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import * as f from '../logic';
import _ from 'lodash';
import { YELLOW, CYAN, RED } from '../../HOME/const';

class Scoreboard extends Component {
  render() {
    const timeLeft = Math.round(this.props.timeLeft / 10);
    const levelColor = f.levelInfo(this.props.level).color;
    const { plays, average, best } = this.props.stats || {};

    return (
      <div className="ms-scoreboard">
        <div className="ms-stats">
          plays<span className="ms-stats-item">{plays}</span>average<span className="ms-stats-item">{average}</span>best
          <span className="ms-stats-item" style={{ marginRight: 0 }}>
            {best}
          </span>
        </div>
        <div className="ms-score">
          {_.map(['solved', 'score', 'strikes'], (s, i) => {
            const area = `1/${i + 1}`;
            const color = i === 0 ? CYAN : i === 1 ? YELLOW : RED;
            return (
              <span key={i} className="ms-score-item" style={{ gridArea: area }}>
                <div className="ms-score-item-value" style={{ color }}>
                  {i === 0 ? this.props.hits : i === 1 ? this.props.score : this.props.misses}
                </div>
                <div className="ms-score-item-label">{s}</div>
              </span>
            );
          })}
        </div>
        <div className="ms-clock">
          <div style={{ gridArea: '1/1', height: '5px', margin: '10px 15px 0 0', background: levelColor }} />
          <div style={{ gridArea: '1/2' }}>{`0:${timeLeft < 10 ? '0' : ''}${timeLeft}`}</div>
          <div style={{ gridArea: '1/3', height: '5px', margin: '10px 0 0 15px', background: levelColor }} />
        </div>
      </div>
    );
  }
}

function mapStateToProps({ ms, common }) {
  return { ...ms, ...common };
}

export default connect(
  mapStateToProps,
  {}
)(Scoreboard);
